import { render, staticRenderFns } from "./NewBaseCheckbox.vue?vue&type=template&id=d8e63cd4&scoped=true&"
import script from "./NewBaseCheckbox.vue?vue&type=script&lang=js&"
export * from "./NewBaseCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./NewBaseCheckbox.vue?vue&type=style&index=0&id=d8e63cd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e63cd4",
  null
  
)

export default component.exports